import React from "react";
import { FACTS } from "../../data/site";

export default function Marquee() {
  const items = [...FACTS, ...FACTS]; // duplicate for seamless loop
  return (
    <section data-testid="marquee-section" className="relative bg-brand-yellow border-y-4 border-slate-900 overflow-hidden">
      <div className="flex w-max animate-marquee py-4">
        {items.map((f, i) => (
          <div key={i} className="flex items-center gap-8 pr-8">
            <span className="font-fredoka font-bold text-lg sm:text-2xl text-slate-900 whitespace-nowrap">
              {f}
            </span>
            <span className="text-2xl">★</span>
          </div>
        ))}
      </div>
    </section>
  );
}
